import { render, staticRenderFns } from "./MovementArtworksImages.vue?vue&type=template&id=c3fff4c2&"
import script from "./MovementArtworksImages.vue?vue&type=script&lang=js&"
export * from "./MovementArtworksImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports